module.exports = {"TXTCLI_Back":{"id":"TXTCLI_Back","defaultMessage":"Back","flags":["TRACK"],"track":"Back"}}